/*********************************************************************************************************************
 *
 * Bit of hacky code that makes wallpaper thumbnails in the cart look more like the crop
 *
 *********************************************************************************************************************/
/* global $ */

function MagicThumb()
{
    var elRoot = this;

    /**
     * Parse a URL-type string
     *
     * @param  {String} str - the inbound string
     * @return {Object} the extracted params
     */
    function parseParams(str)
    {
        if ((str === null) || (str === ''))
        {
            return null;
        }
        var oParam = {};
        str.split('&').forEach(function(param)
        {
            var aM;
            if ((aM = param.match(/^(\w+)(?:=(.*?))?$/)) !== null)
            {
                if (aM[2] === undefined)
                {
                    oParam[aM[1]] = true;
                }
                else if (aM[2].match(/^-?\d+(\.\d+)?$/))
                {
                    oParam[aM[1]] = parseFloat(aM[2]);
                }
                else
                {
                    oParam[aM[1]] = aM[2];
                }
            }
        });

        return oParam;
    }

    /**
     * Applies the actual crop to the image.
     *
     * @param   {HTMLElement} img - the image we’re sourcing from
     * @param   {Object} oParam - the parameters we’re using to do things
     */
    function applyCrop( img, oParam )
    {
        // 1. hide the image
        img.style.opacity = 0;

        // 2. basic styling of the root element
        elRoot.style.display = 'block';
        elRoot.style.backgroundImage = 'url(' + img.src + ')';
        elRoot.style.backgroundSize = 'cover';
        elRoot.style.backgroundRepeat = 'no-repeat;'

        // 3. adjust the height of the component based on the aspect ratio
        elRoot.style.height = (( oParam.height / oParam.width ) * elRoot.scrollWidth ) + 'px';

        // 4. position it (this gets more fun)
        // a. get an aspect ratio
        var fAspect = oParam.width / oParam.height;
        var fXOff = 0;
        var fYOff = 0;

        // b. get a pretend version of the image that we can query for size
        var fakeImage = new Image;
        fakeImage.src = img.src;
        fakeImage.title = img.title;
      
     

        // b. work out the appropriate offsets based on dimensions
        if ((fakeImage.width / fakeImage.height) > fAspect)
        {
            fXOff = (elRoot.scrollHeight / fakeImage.height) * fakeImage.width * (oParam.left / 100);
        }
        else
        {
            fYOff = (elRoot.scrollWidth / fakeImage.width) * fakeImage.height * (oParam.top / 100);
        }

        // c. flip and apply units, if required
      
        
        if(fakeImage.title == "true") {
          var calcX = (fXOff === 0) ? 0 : (fXOff * -1) + 'px';
          fXOff = 'calc(100% - '+ calcX + ')';
        } else {
         fXOff = (fXOff === 0) ? 0 : (fXOff * -1) + 'px'; 
        }
      
      //fXOff = (fXOff === 0) ? 0 : (fXOff * -1) + 'px'; 
        fYOff = (fYOff === 0) ? 0 : (fYOff * -1) + 'px';

        // d. set everything
        elRoot.style.backgroundPosition = fXOff + ' ' + fYOff;

    }

    /**
     * Constructor
     */
    (function init()
    {
        // look for the image
        var img = elRoot.querySelector('img');
        if (img === null)
        {
            return false;
        }

        // parse the query string
        var oParam = parseParams(elRoot.getAttribute('data-mt-attrs'));
        if (oParam === null)
        {
            return false;
        }

        // apply it
        applyCrop( img, oParam );
        return true;
    }())
}
$(window).load(function() {
    $('[data-behaviour="magic-thumb"]').each(MagicThumb);
});
